import { render, staticRenderFns } from "./NewReturnButton.vue?vue&type=template&id=9f1532a0&scoped=true&"
import script from "./NewReturnButton.vue?vue&type=script&lang=ts&"
export * from "./NewReturnButton.vue?vue&type=script&lang=ts&"
import style0 from "./NewReturnButton.vue?vue&type=style&index=0&id=9f1532a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1532a0",
  null
  
)

export default component.exports